import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useModelTraining } from '.';

export default function TriggerWordInput() {
  const { triggerWord, setTriggerWord } = useModelTraining();

  return (
    <div className='px-4 space-y-2'>
      <Label
        htmlFor='trigger-word'
        className='text-base font-semibold text-neutral-50 leading-tight'
      >
        Trigger Word
      </Label>
      <Input
        id='trigger-word'
        placeholder='Enter a trigger word (e.g., ANDN)'
        value={triggerWord}
        onChange={(e) => setTriggerWord(e.target.value)}
        className='bg-neutral-800 border border-white/10 text-stone-50/90 text-sm placeholder:text-stone-50/90/40 focus:ring-2 focus:ring-fuchsia-600/50 focus:border-fuchsia-600 transition'
      />
      <Label className='text-xs text-stone-50/60'>
        Word used to activate your model in prompts.
      </Label>
    </div>
  );
}
